(ns frontend.view.settings2.api-integrations.view
  (:require [common.localization :as loc]
            [frontend.routing :as routing]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.view.settings2.api-integrations.db :as db]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [ui.components.breadcrumbs.view :as breadcrumbs]))

(defn breadcrumbs []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "data"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/api-integrations)]])


(defn advertisement []
  [:div
   {:class "px-4 py-8 mx-auto lg:w-4xl"}
   [:div
    [:div
     [:p
      {:class "p-6 flex flex-col gap-4 text-primary-regular-text bg-[url('/img/gradient-bg.png')] bg-no-repeat bg-cover rounded-md"}
      [:span
       {:class "block font-semibold text-2xl"}
       "Zapflow has a very powerful and flexible restful API "
       [:div
        [:span {:class "inlin-block"} "which is available in "]
        [:span {:class "inline-block font-bold"}
         " our premium plans"]]]

      [:span
       {:class "flex items-center gap-4 leading-6"}
       [:span  "To get started with your integration needs."]
       [:a {:href   "mailto:sales@zapflow.com"
            :target "_blank"
            :class "py-3 px-4 inline-block text-primary-regular-text font-bold border border-solid focus:border-primary-regular-border-paler hover:border-primary-regular-border-accent focus:border-primary-regular-border-accent rounded"}
        "Contact us"]]]]]])

(defmethod routing/render-view :new-settings/api-integrations [_]
  [default-page-layout/view
   [:<>
    [zap-toolbar/view db/state breadcrumbs nil nil]
    [advertisement]]])
